export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_complete_7.6a7911ae.jpg";